export type DashboardTypes = 'pull-requests' | 'issues' | 'repositories'

export const dashboardTypeLabels: Record<DashboardTypes, string> = {
  'pull-requests': 'pull requests',
  issues: 'issues',
  repositories: 'repositories',
}

export const dashboardTypeLabelSingular: Record<DashboardTypes, string> = {
  'pull-requests': 'pull request',
  issues: 'issue',
  repositories: 'repository',
}
